import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IJobOrder, defaultValue } from 'app/shared/model/job-order.model';

export const ACTION_TYPES = {
  FETCH_JOBORDER_LIST: 'jobOrder/FETCH_JOBORDER_LIST',
  FETCH_JOBORDER: 'jobOrder/FETCH_JOBORDER',
  CREATE_JOBORDER: 'jobOrder/CREATE_JOBORDER',
  UPDATE_JOBORDER: 'jobOrder/UPDATE_JOBORDER',
  DELETE_JOBORDER: 'jobOrder/DELETE_JOBORDER',
  RESET: 'jobOrder/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IJobOrder>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type JobOrderState = Readonly<typeof initialState>;

// Reducer

export default (state: JobOrderState = initialState, action): JobOrderState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_JOBORDER_LIST):
    case REQUEST(ACTION_TYPES.FETCH_JOBORDER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_JOBORDER):
    case REQUEST(ACTION_TYPES.UPDATE_JOBORDER):
    case REQUEST(ACTION_TYPES.DELETE_JOBORDER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_JOBORDER_LIST):
    case FAILURE(ACTION_TYPES.FETCH_JOBORDER):
    case FAILURE(ACTION_TYPES.CREATE_JOBORDER):
    case FAILURE(ACTION_TYPES.UPDATE_JOBORDER):
    case FAILURE(ACTION_TYPES.DELETE_JOBORDER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_JOBORDER_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_JOBORDER):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_JOBORDER):
    case SUCCESS(ACTION_TYPES.UPDATE_JOBORDER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_JOBORDER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/job-orders';

// Actions

export const getEntities: ICrudGetAllAction<IJobOrder> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_JOBORDER_LIST,
  payload: axios.get<IJobOrder>(`${apiUrl}?cacheBuster=${new Date().getTime()}`)
});

export const getEntity: ICrudGetAction<IJobOrder> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_JOBORDER,
    payload: axios.get<IJobOrder>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IJobOrder> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_JOBORDER,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IJobOrder> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_JOBORDER,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IJobOrder> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_JOBORDER,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
